module.exports = __webpack_public_path__ + "img/DE01007.78055d37.png";